import styled from "styled-components";
import { colors } from "../../../common/ui/globalColors";

export const StyledApartmentReport = styled.div`
  .title-wrapper {
    h1 {
      font-size: 26px;
      line-height: 30px;
    }
  }

  .dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    margin: 30px 0;

    .select {
      width: 200px;
      color: ${props => props.theme.text};

      & div {
        font-size: 16px;
      }

      & div[class$='-indicatorContainer'] {
        box-shadow: 1px 1px 10px -2px rgba(45, 76, 140, 0.5);
      }
    }
  }

  .page-tabs {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;

    .tab {
      border: 1px solid ${colors.semiTransparentColors.lightBlue};
      border-radius: 100px;
      padding: 9px 24px;
      position: relative;
      width: 200px;
      color: ${colors.semiTransparentColors.grayBlue};
      display: flex;
      gap: 12px;
      cursor: pointer;
      font-size: 16px;
      line-height: 18px;
      height: 38px;

      .radio-btn-outer {
        width: 16px;
        height: 16px;
        border: 1px solid ${colors.semiTransparentColors.lightBlue};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: ${({ ltr }) => ltr ? '10px' : ''};
        left: ${({ ltr }) => ltr ? '' : '10px'};

        .radio-btn-inner {
          width: 6.4px;
          height: 6.4px;
          background: ${colors.semiTransparentColors.lightBlue};
          border-radius: 50%;
        }
      }
    }

    .tab.selected {
      color: ${colors.textColors.black};
      background: ${colors.additionalColors.lightGray};
      border: 1px solid ${colors.additionalColors.lightGray};

      .radio-btn-outer {
        border: 1px solid ${colors.additionalColors.gradientBlue};

        .radio-btn-inner {
          background: ${colors.primaryColors.bllinkGradient};
        }
      }
    }
  }

  // common styling for children components

  .switch-wrapper {
    width: 420px;
    height: 38px;

    .react-switch-selector-wrapper {
      direction: ltr;
      
      :before {
        height: 100%;
        width: 50%;
      }
    }

    .react-switch-selector-option-label {
      margin: 0;
      font-size: 16px;
    }
  }

  .ScrollbarsCustom-Content {
    padding-right: 22px !important;
  }

  .top-bar {
    display: flex;
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
    justify-content: flex-start;
    gap: 16px;
    margin-bottom: 28px;

    .search {
      position: relative;
      font-size: 15px;
      line-height: 24px;
      color: ${props => props.theme.text};

      input {
        padding: 8px 20px;
        border: none;
        border-radius: 25px;
        box-shadow: 0 3px 10px ${colors.semiTransparentColors.shadowGray};

        &::placeholder {
          color: ${colors.semiTransparentColors.grayBlue};
        }
      }

      img {
        position: absolute;
        left: ${({ ltr }) => ltr ? '' : '15px'};
        right: ${({ ltr }) => ltr ? '15px' : ''};
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
      }
    }

    .select {
      width: 210px;

      &::placeholder {
        color: ${colors.semiTransparentColors.grayBlue};
      }
    }
  }
`
